import React from 'react';

import { AppSettingsContext, FirebaseContext, HttpClientContext, ScreenSizeContext, SnackbarContext, ConfirmContext, AuthContext } from '@dw/contexts';

export { useRouteData } from './useRouteData';
export { useBinaryToggle } from './useBinaryToggle';
export { useFileUploader } from './useFileUploader';
export { useStorage } from './useStorage';
export { useSessionStorage } from './useSessionStorage';
export { useActiveEnrolmentYear } from './useActiveEnrolmentYear';

export const useAppSettings = () => React.useContext(AppSettingsContext);
export const useHttpClient = () => React.useContext(HttpClientContext);
export const useSnackbar = () => React.useContext(SnackbarContext);
export const useFirebase = () => React.useContext(FirebaseContext);
export const useScreenSize = () => React.useContext(ScreenSizeContext);
export const useConfirm = () => React.useContext(ConfirmContext);
export const useAuth = () => React.useContext(AuthContext);